<template>
    <b-container fluid class="py-3">
        <b-row>
            <b-col>
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                    <MasterEmpty v-if="items.length === 0" eheader="Supplier Payment" econtent="Supplier Payment"
                        eimg="/src/assets/Img/icons/supplier-mapping.svg" :createline="false" />
                    <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                        :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                        :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                        selectionMode="single" dataKey="ID">
                        <template v-slot:action="{ data }">
                            <i class="pi pi-eye eyeicon" title="View Details" @click="viewdetails(data)"></i>
                        </template>
                    </Tableview>
                </div>
            </b-col>
        </b-row>
    </b-container>

</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useRouter, useRoute } from "vue-router";
import SupplierPaymentService from "../../../../../../modules/Inventory/Service/SupplierPrePayment";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";

export default defineComponent({
    components: {
        Tableview,
        SkeletonTableLoader,
        MasterEmpty
    },

    setup() {
        onMounted(() => {
            IsShow();
        });
        //get local storage session data
        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }
        //Declaration
        const router = useRouter();
        const route = useRoute();
        const items = ref([]);
        const loading = ref(false);
        //DataTable Fields
        const headers = [
            {
                header: "S.No",
                field: "RowNumber",
                class: 'filterdisplaynone'
            },
            {
                header: "Supplier Id",
                field: "Code",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Supplier Name",
                field: "Name",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',
            },
            {
                header: "Phone",
                field: "PhoneNo",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',
            },
            {
                header: "Mail",
                field: "EmailId",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',
            },
            {
                header: 'PO Count',
                field: 'POCount',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },

            {
                header: 'Number Of Invoices',
                field: 'TotalInvoiceNo',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'Total Outstanding',
                field: 'TotalOutstanding',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            // {
            //     header: 'Number of Debit Notes',
            //     field: 'TotalDebitNotes',
            //     filterTemplate: 'MultiSelect',
            //     ShowMactchMode: false,
            //     class: 'width150'
            // },
            // {
            //     header: 'Total Debit Note Value',
            //     field: 'DebitValues',
            //     filterTemplate: 'MultiSelect',
            //     ShowMactchMode: false,
            // },
            // {
            //     header: 'Prepayments',
            //     field: 'Prepayment',
            //     filterTemplate: 'MultiSelect',
            //     ShowMactchMode: false,
            // },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },

        ];

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            SupplierId: { value: null, matchMode: FilterMatchMode.IN, options: items },
            SupplierName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            ContactDetails: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TotalInvoiceNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TotalOutstanding: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TotalDebitNotes: { value: null, matchMode: FilterMatchMode.IN, options: items },
            DebitValues: { value: null, matchMode: FilterMatchMode.IN, options: items },
            Prepayment: { value: null, matchMode: FilterMatchMode.IN, options: items },
        };

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });
        const globalFilterFields = ref(headers.map((col) => col.field));
        async function IsShow() {

            try {
                loading.value = true;
                let count = 0;
                debugger
                const dataresponse = await SupplierPaymentService.GetSupplierDetailsList(usersData.OrganizationId, usersData.BranchId, Number(route.query.storebranchmapid));
                items.value = dataresponse["result"].map((item: any) => {
                    count = count + 1;
                    item.RowNumber = count;
                    return item;
                });
                loading.value = false;
            } catch (error) {
                console.log(error);
            }
        }
        function viewdetails(data) {
            debugger
            router.push({
                name: "SupplierPaymentDetails",
                query: {
                    Id: data.SupplierId,
                    StoreId: Number(route.query.Id),
                    StoreBranchMapId: Number(route.query.storebranchmapid),
                },
            });
        }
        return {
            items,
            loading,
            filteredColumns,
            globalFilterFields,
            headers,
            filters,
            viewdetails,
            IsShow
        }
    }

})
</script>

<style lang="scss" scoped></style>